

























































import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import PeriodPicker from '@/components/PeriodPicker';
import {mapGetters} from 'vuex';

@Component({
  name: 'ChangePriceBlock',
  components: {
    PeriodPicker,
  },
  created() {},
  props: {
    translations: {
      type: Object,
      default: () => {},
    },
    apartment: {
      type: Object,
      default: () => {},
    },
    errorPrice: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      servicePrice: 0,
      userPrice: null,
      recommendedPrice: this.apartment ? this.apartment.recommended_price : 0,
    };
  },
  computed: {
    ...mapGetters(['percentForServices']),
    userPriceValue: {
      get() {
        return this.userPrice ?? this.apartment?.rent_ad_request?.price ?? this.apartment?.recommended_price;
      },
      set(value) {
        this.userPrice = '';
        this.userPrice = value.length > 5 ? value.slice(0, 5) : value;
        return this.userPrice;
      },
    },

    actualPrice() {
      if (this.userPrice) {
        this.servicePrice = this.userPrice * (this.percentForServices / 100);
        return parseInt((this as any).userPrice, 10);
      } else {
        const defaultPrise = this.apartment?.rent_ad_request?.price || this.apartment?.recommended_price;
        this.servicePrice = defaultPrise * (this.percentForServices / 100);
        return parseInt(defaultPrise, 10);
      }
    },

    totalPrice() {
      return parseInt(this.actualPrice, 10) - this.servicePrice;
    },

  },
  methods: {
    changePrice() {
      this.$emit('changeUserPrice', (this as any).userPriceValue);
    },
  },
})
export default class ChangePriceBlock extends Vue {}
